

let liveLimit=false;
const dragDirective = {
  beforeMount(el) {
    el.style.touchAction = 'none'; // 禁止默认的 touch 事件
    el.addEventListener('touchstart', handleTouchStart, { passive: false });
    el.addEventListener('touchmove', handleTouchMove, { passive: false });
    el.addEventListener('touchend', touchend, { passive: false });
  },
  unmounted(el) {
    el.removeEventListener('touchstart', handleTouchStart);
    el.removeEventListener('touchmove', handleTouchMove);
    el.removeEventListener('touchend', touchend);
  },
};

const screenWidth = window.innerWidth;
const screenHeight = window.innerHeight;
// 记录初始坐标和偏移量
let startX = 0;
let startY = 0;
let offsetX = 0;
let offsetY = 0;

function handleTouchStart(e) {
  liveLimit = [...this.classList].some((e)=>{return e=='liveLimit'});
  // console.log('liveLimit', liveLimit );
  startX = e.touches[0].pageX;
  startY = e.touches[0].pageY;
  offsetX = this.offsetLeft;
  offsetY = this.offsetTop;
}

function handleTouchMove(e) {
  e.preventDefault(); // 阻止滚动
  const dx = e.touches[0].pageX - startX;
  const dy = e.touches[0].pageY - startY;
  
  if(liveLimit){
    this.style.top = Math.max(0, Math.min(Math.max(350,offsetY + dy), screenHeight - 90)) + 'px';
  }else{
    this.style.top = Math.max(0, Math.min(offsetY + dy, screenHeight - 70)) + 'px';
  }
  this.style.left = Math.max(0, Math.min(offsetX + dx, screenWidth - 50)) + 'px';
}

function touchend(e){
  // e.preventDefault(); // 阻止滚动
  const elWidth = this.offsetWidth;
  const elHeight = this.offsetHeight;
  const elLeft = parseInt(this.style.left);
  const elTop = parseInt(this.style.top);

  if (elLeft + elWidth / 2 < screenWidth / 2) {
    this.style.left = '5px';
  } else {
    this.style.left = screenWidth - elWidth -5+ 'px';
  }
  this.style.top = Math.max(0, Math.min(elTop, screenHeight - elHeight)) + 'px';
}

export default dragDirective;